import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import ConnUrls from '../Connections/ConnectURL';
import utilsRests from '../_Utils/utilsRests';
import { Link } from "react-router-dom";
import MySpinner_Wait from './MySpinner_Wait';

const SearchComp2 = forwardRef((props, ref) => {
  const [txtToSearch, setTxtToSearch] = useState('');
  const [matchingItems, setMatchingItems] = useState([]);
  const [displayedItems, setDisplayedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visibleCount, setVisibleCount] = useState(10); // Show 10 items initially

  const typingTimerRef = useRef(null);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  // Expose focus method to parent component
  useImperativeHandle(ref, () => ({
    focus: () => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  }));

  // Sync with external value if provided
  useEffect(() => {
    if (props.value !== undefined && props.value !== txtToSearch) {
      setTxtToSearch(props.value);
    }
  }, [props.value]);

  // Reset visible count when matchingItems changes
  useEffect(() => {
    setDisplayedItems(matchingItems.slice(0, visibleCount));
  }, [matchingItems, visibleCount]);

  // Lazy loading on scroll
  const handleScroll = (e) => {
    const element = e.target;
    const scrollTop = element.scrollTop;
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;
    
    // Load more when near bottom (50px threshold)
    const isNearBottom = scrollTop + clientHeight >= scrollHeight - 50;

    if (isNearBottom && visibleCount < matchingItems.length) {
      setVisibleCount(prev => Math.min(prev + 10, matchingItems.length));
    }
  };

  const getByTyping = (searchText) => {
    clearTimeout(typingTimerRef.current); // Clear previous timer

    // Minimum 2 characters required for search
    if (searchText.trim().length < 2) {
      setMatchingItems([]);
      setDisplayedItems([]);
      setVisibleCount(10); // Reset count
      setLoading(false);
      return;
    }

    typingTimerRef.current = setTimeout(async () => {
      setLoading(true)
      if (searchText.trim() !== "") {
        const filteredItems = await utilsRests.getallBuisSmallLst(searchText);
        setMatchingItems(filteredItems);
        setVisibleCount(10); // Reset to show first 10
      } else {
        setMatchingItems([]);
        setDisplayedItems([]);
      }
      setLoading(false)
    }, 500);
  };

  const checkIfEnter = (e) => {
    if (e.key === 'Enter') {
      searchMe();
      // Remove focus from input to close mobile keyboard
      if (inputRef.current) {
        inputRef.current.blur();
      }
    }
  };

  const searchMe = () => {
    props.srchFunc(txtToSearch);
    // Remove focus from input to close mobile keyboard
    if (inputRef.current) {
      inputRef.current.blur();
    }
  };

  const clearSearch = () => {
    setTxtToSearch('');
    setMatchingItems([]);
    setDisplayedItems([]);
    setVisibleCount(10);
  };

  return (
    <>
      <div className="SearchDiv" style={{ position: 'relative' }}>
        {txtToSearch && (
          <span
            onClick={clearSearch}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              fontSize: '18px',
              color: '#4a4a4a',
              fontWeight: 'bold',
              padding: '5px',
              lineHeight: '40px'
            }}
          >
            ×
          </span>
        )}
        <input
          ref={inputRef}
          type="text"
          value={txtToSearch}
          onKeyUp={(e) => checkIfEnter(e)}
          onChange={(e) => { 
            setTxtToSearch(e.target.value); 
            getByTyping(e.target.value);
            if (props.onSearchChange) {
              props.onSearchChange(e.target.value);
            }
          }}
          placeholder={props.pHolder}
        />

        <img id="searchBtn" src="/PermanentImages/searchIc.gif" alt="" onClick={() => searchMe()} />
      </div>
      {props.showDropdown !== false && (loading || matchingItems.length > 0) && (
        <div className="searchDropdown">
          {loading ? <MySpinner_Wait /> : (
            <ul className="dropdown-content" ref={dropdownRef} onScroll={handleScroll}>
              {displayedItems.map((item, indx) => (
                <li key={indx}>
                  <Link to={{
                    pathname: `/restaurants/${item.pageUrlFix != null && item.pageUrlFix != "" ? item.pageUrlFix : item._id}`,
                    state: { waitImg: item.waitingImg }
                  }
                  }
                    onClick={() => utilsRests.logSearchTerm(txtToSearch)}
                  >

                    <div className="dropdown-item">
                      <img className={'thumbImg'} src={ConnUrls.media(item.buissMainImg)} alt={item.buissName} />
                      <div style={{ flex: 1 }}>
                        <span className={''}>{item.buissName}</span>
                        {item.matchReason && item.matchReason !== 'name' && item.matchReason !== 'keyword' && (
                          <div style={{ fontSize: '0.85em', color: '#666', marginTop: '4px' }}>
                            {item.matchReason === 'menu' && `🏷️ קטגוריה: ${item.matchText}`}
                            {item.matchReason === 'product' && `🍴 מנה: ${item.matchText}`}
                            {item.matchReason === 'supermarket-menu' && `🏷️ קטגוריה: ${item.matchText}`}
                            {item.matchReason === 'supermarket-product' && `🛒 מוצר: ${item.matchText}`}
                          </div>
                        )}
                      </div>
                    </div>
                  </Link>
                </li>
              ))}
              {visibleCount < matchingItems.length && (
                <li className="dropdown-item" style={{ textAlign: 'center', color: '#999' }}>
                  גלול למטה לעוד תוצאות... ({matchingItems.length - visibleCount} נוספים)
                </li>
              )}
            </ul>
          )}
        </div>
      )}
    </>
  );
});

export default SearchComp2;
